import PropTypes from "prop-types";
import {
  ProductImageOrientation,
  ProductImageSize,
  getProductImageAltText,
  getProductImageUrlsByOrientation,
} from "helpers/product-image-helpers";
import ProductImagePath from "helpers/product-image-path";
import ProductImage from "components/source/shared/product-image";
import classNames from "classnames";

const propTypes = {
  productData: PropTypes.object,
  bookingId: PropTypes.number,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

const HappinessSurveyGridItem = ({ productData, bookingId, isSelected, onClick = () => {}, disabled, size = null }) => {
  const fallBackThumbnailImgSrc = () =>
    productData?.images?.[ProductImageOrientation.NO_MODEL.path]
      ? ProductImagePath + productData.images[ProductImageOrientation.NO_MODEL.path]?.[ProductImageSize.x480.path]
      : ProductImagePath + productData?.images?.[ProductImageOrientation.FRONT.path]?.[ProductImageSize.x480.path];

  const getProductImage = isSelected => {
    const className = classNames("w-full aspect-2/3 rounded-lg", {
      "opacity-50": disabled,
      "outline outline-2 outline-wine": !disabled && isSelected,
    });

    return (
      <ProductImage
        className={className}
        altText={getProductImageAltText(productData?.displayName, productData?.designer?.displayName)}
        imageGroup={getProductImageUrlsByOrientation(productData?.images, [ProductImageOrientation.NO_MODEL.path])}
        imageSize={ProductImageSize.x480}
        fallbackSrc={fallBackThumbnailImgSrc()}
        disabled={disabled}
      />
    );
  };

  const sizePill = () => {
    if (!size) return null;
    return <div className="absolute bottom-1 left-1 p-1 bg-darkerGray text-sm rounded-md text-white">Size {size}</div>;
  };

  const radio = () => {
    return (
      <div className="absolute top-1 right-1">
        {isSelected ? (
          <svg
            data-test-id="customRadioSvg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="text-wine"
            xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="white" />
            <path
              d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6Z"
              fill="currentColor"
            />
          </svg>
        ) : (
          <svg
            data-test-id="customRadioSvg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="text-darkGray"
            xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="white" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              fill="currentColor"
            />
          </svg>
        )}
      </div>
    );
  };

  const onClickItem = () => {
    onClick(bookingId);
  };

  return (
    <button data-test-id="happiness-survey-grid-item" className="relative" onClick={onClickItem}>
      {getProductImage(isSelected)}
      {radio()}
      {sizePill()}
    </button>
  );
};

HappinessSurveyGridItem.propTypes = propTypes;
export default HappinessSurveyGridItem;
